import { typeActionCreator, valueActionCreator } from "../action_creators";
export var CUSTOM_FIELDS_CREATE = 'CUSTOM_FIELDS_CREATE';
export var CUSTOM_FIELDS_REMOVE = 'CUSTOM_FIELDS_REMOVE';
export var customFieldsCreateAction = typeActionCreator(CUSTOM_FIELDS_CREATE);
export var customFieldsRemoveAction = valueActionCreator(CUSTOM_FIELDS_REMOVE);